export const DataTypes = {

    MEDICATIONS: "medications"
}

export const ActionTypes = {

  DATA_LOAD: "data_load"

}